<template>
  <div class="session-recording">
    <div v-if="initializing">Processing...</div>
<!--    <div v-if="processing">{{this.sessionLog.compositionPercentage}}% {{this.sessionLog.compositionSecondsLeft}}s left</div>-->
    <div v-if="processing">Processing... </div>
    <template v-if="finished">
      <a class="fa-icon" :href="downloadLink" target="_blank" v-tooltip.auto="'Download'">
        <fa-icon icon="cloud-download-alt"/>
      </a>
      <div class="fa-icon" @click="showRecordingPreview" v-tooltip.auto="'Play'">
        <fa-icon icon="play"/>
      </div>
    </template>
    <div class="fa-icon" v-if="hasScreenshots" @click="openScreenshotsPreview" v-tooltip.auto="'Snapshots'">
      <fa-icon icon="camera"/>
    </div>
    <div class="fa-icon" @click="openNotesPreview" v-tooltip.auto="'Notes'">
      <fa-icon icon="sticky-note"/>
    </div>
<!--    <div v-if="noRecording && !hasScreenshots && !hasNotes">-->
<!--      - -->
<!--    </div>-->
    <transition name="recording-preview">
      <recording-preview
        v-if="isRecordingPreviewShown"
        :session-log="sessionLog"
        @close="closeRecordingPreview"
      />
    </transition>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import RecordingPreview from "./RecordingPreview";

  export default {
    name: 'SessionRecording',
    components: {RecordingPreview},
    props: {
      sessionLog: {
        type: Object
      }
    },

    data: () => ({
      isRecordingPreviewShown: false
    }),

    computed: {
      ...mapState({
        authToken: state => state.auth.token
      }),

      initializing() {
        return this.sessionLog.compositionSid
          && !this.sessionLog.compositionPercentage
          && !this.sessionLog.hasRecording
      },
      processing() {
        return this.sessionLog.compositionSid
          && this.sessionLog.compositionPercentage
          && !this.sessionLog.hasRecording
      },
      finished() {
        return this.sessionLog.compositionSid
          && this.sessionLog.hasRecording
      },
      noRecording() {
        return !this.sessionLog.compositionSid
          && !this.sessionLog.hasRecording
      },
      downloadLink() {
        let apiUrl = process.env.VUE_APP_API_URL || 'https://arstream.vitech.dev';
        return `${apiUrl}/composition/download/${this.sessionLog.compositionSid}?token=${this.authToken}`
      },
      hasScreenshots() {
        return this.sessionLog.screenshots.length
      },
      hasNotes() {
        return this.sessionLog.notes && this.sessionLog.notes.length
      }
    },

    methods: {
      showRecordingPreview() {
        this.isRecordingPreviewShown = true
      },
      closeRecordingPreview() {
        this.isRecordingPreviewShown = false
      },
      openScreenshotsPreview() {
        this.$emit('openScreenshotsPreview')
      },
      openNotesPreview() {
        this.$emit('openNotesPreview')
      }
    }
  }
</script>

<style lang="scss">
@import "SessionRecording";
</style>
